import { useEffect, useRef } from 'react';
import type { UseIsComponentMounted } from './types';

/**
 * Check if component is mounted or not.
 *
 * @returns Boolean
 */

const useIsComponentMounted: UseIsComponentMounted = () => {
  const isMounted = useRef<boolean>(false);

  useEffect(() => {
    isMounted.current = true;

    return () => {
      isMounted.current = false;
    };
  }, []);

  return isMounted;
};

export default useIsComponentMounted;
